/** @license ISC License (c) copyright 2018 original and current authors */
/** @author Dale Francis (dalefrancis88) */

var Pred = require('./types').proxy('Pred')

var isFunction = require('./isFunction')
var isSameType = require('./isSameType')

// isPredOrFunc :: ((a -> b) | pred) -> bool
var isPredOrFunc = function (predOrFunc) { return isFunction(predOrFunc) || isSameType(Pred, predOrFunc); }

module.exports = isPredOrFunc
